export default "__VITE_ASSET__bm6hykH7__"